import { useLocation, Link } from "react-router-dom";

const Sidebar = () => {
  const pathname = useLocation().pathname;
  return (
    <>
      {pathname == "/mypage/top" || pathname === "/mypage/apierror" ? (
        <></>
      ) : (
        <div className="l-page-left">
          <div className="p-sidebar">
            <ul className="p-sidebar-list">
              <li className="p-sidebar-item">
                <Link className="p-sidebar-link" to="/mypage/top">
                  トップページ
                </Link>
              </li>
              <li className="p-sidebar-item">
                <Link className="p-sidebar-link" to="/mypage/user/">
                  ユーザー情報の確認・変更
                </Link>
              </li>
              <li className="p-sidebar-item">
                <Link className="p-sidebar-link" to="/mypage/news/1">
                  お知らせ
                </Link>
              </li>
              <li className="p-sidebar-item">
                <Link
                  className="p-sidebar-link"
                  to="/mypage/course/search/accepting"
                >
                  講座検索
                </Link>
              </li>
              <li className="p-sidebar-item">
                <Link className="p-sidebar-link" to="/mypage/course/applied">
                  申込状況・受講履歴
                </Link>
              </li>
              <li className="p-sidebar-item">
                <a
                  className="p-sidebar-link"
                  href={process.env.REACT_APP_SHIBUKATSU_WEB_DOMAIN + "/jukou/"}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  受講にあたって（新しいウィンドウで開きます）
                </a>
              </li>
            </ul>
          </div>
        </div>
      )}
    </>
  );
};
export default Sidebar;
